import { useTranslation } from "next-i18next";
import { Footer2026 } from "../../../components/Footer2026";
import ContactSectionForm from "../../../components/ContactSectionForm";
import { TopbarLanding } from "../../../components/LandingPage/topbar";
import DefaultDarkModeHOC from "../../../components/theme/DefaultDarkModeHOC";
import WhatsAppButton from "../../../components/WhatsAppButton";
import {
	getI18nPaths,
	getI18nProps,
} from "../../../lib/next-i18next/getStatic";
import { FaceLiftGlobalStyle } from "../../../styles/theme";
import { ProductMetadata } from "./product-metadata";
import HeroSection from "./views/hub-talentos-sections/HeroSection";
import InfosSection from "./views/hub-talentos-sections/InfosSection";
import DiferenciaisSection from "./views/hub-talentos-sections/DiferenciaisSection";
import DesafiosResultadosSection from "./views/hub-talentos-sections/DesafiosResultadosSection";
import AtividadesSection from "./views/hub-talentos-sections/AtividadesSection";
import AlocacaoSection from "./views/hub-talentos-sections/AlocacaoSection";
import EmpresasSection from "./views/hub-talentos-sections/EmpresasSection";
import DepoimentosSection from "./views/hub-talentos-sections/DepoimentosSection";

export default function HubTalentosPage(data) {
	const { t } = useTranslation();

	return (
		<DefaultDarkModeHOC>
			<ProductMetadata
				translations={data.translations}
				slug="hub-talentos"
				imagePath="/landings/assets/images/products/hub-talentos/hero-bg.jpg"
			/>
			<TopbarLanding />
			<FaceLiftGlobalStyle />

			<main className="bg-neutral-08">
				<HeroSection />
				<InfosSection />
				<DiferenciaisSection />
				<DesafiosResultadosSection />
				<AtividadesSection />
				<AlocacaoSection />
				<EmpresasSection />
				<DepoimentosSection />

				<ContactSectionForm
					title={t("products.hub-talentos.contact.title")}
					description={t("products.hub-talentos.contact.description")}
					buttonText={t("products.hub-talentos.contact.buttonText")}
				/>
			</main>

			<WhatsAppButton />
			<Footer2026 />
		</DefaultDarkModeHOC>
	);
}

export async function getStaticProps(ctx) {
	const locale = ctx.params?.locale || "pt";
	const i18nProps = await getI18nProps(ctx);
	const translations =
		i18nProps._nextI18Next.initialI18nStore[locale].translation;

	return {
		props: {
			...i18nProps,
			translations,
			product: {
				slug: "hub-talentos",
				locale,
			},
		},
	};
}

export async function getStaticPaths() {
	const paths = getI18nPaths([{ slug: "hub-talentos" }]);

	return {
		paths,
		fallback: false,
	};
}
